import React from "react";
import "./index.css"

const CurvedText = () => {
    return (
        <div className="curvedText">
            <div>F</div>
            <div>E</div>
            <div>I</div>
            <div>R</div>
            <div>I</div>
            <div>N</div>
            <div>H</div>
            <div>A</div>
        </div>
    )
}

export default CurvedText